<span [ngSwitch]="type" *ngFor="let customer of customer">

  <ng-container *ngSwitchCase="tablesTranslations.i18nCustomerData">

    <div class="esf-info-tile-grid__item"
         cdkDropList
         [id]="id"
         cdkDropListSortingDisabled
         [cdkDropListData]="customer"
         cdkDropListConnectedTo="mergedCustomerData">
      <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
        <span class="esf-action-heading__text">{{ type }}</span>
      </h4>
      <div class="esf-info-tile">
        <div class="esf-info-tile__content">
          <div class="esf-grid esf-grid--gutter-y-xxs esf-grid--x-between esf-grid--center-y"
               [class.cdk-drag--keep-opacity]="viewOnly"
               cdkDrag
               [ngClass]="['drag-item']"
               [cdkDragData]="setDragData(customer, ['externalNumber', 'state', 'id', '@id'])"
               [cdkDragDisabled]="checkIfExists(customer.externalNumber, 'externalNumber')">
            <div class="esf-grid__item">
              <div class="esf-icon-and-text esf-icon-and-text--xs">
                <svg class="esf-icon esf-icon-and-text__icon" width="16" height="16">
                  <use xlink:href="#esf-icon-user-number"></use>
                </svg>
                <div class="esf-icon-and-text__text">{{ customer.externalNumber }}</div>
              </div>
            </div>
            <div class="esf-grid__item" [class.cdk-drag-placeholder]="!customer.state">
              <a class="esf-tag" [ngClass]="customer.state.status.class">{{ customer.state.status.status || '/' }}</a>
            </div>
          </div>

          <p>
            <small>
              <span cdkDrag
                    [class.cdk-drag--keep-opacity]="viewOnly"
                    [cdkDragData]="setDragData(customer, ['salutation', 'title', 'firstName', 'lastName', 'gender'])"
                    [cdkDragDisabled]="checkIfNameExists(customer, ['salutation', 'title', 'firstName', 'lastName'])">
                <span class="name-prefix">{{ customer.salutation?.getTranslatedSalutation }} </span>
                <span class="title">{{ customer.title }} </span>
                <span class="firstName">{{ customer.firstName }} </span><span class="lastName">{{ customer.lastName }}</span><br>
              </span>
              <span cdkDrag
                    [class.cdk-drag--keep-opacity]="viewOnly"
                    [cdkDragData]="setDragData(customer, ['company'])"
                    [cdkDragDisabled]="checkIfExists(customer.company, 'company')"
                    class="company" *ngIf="customer.company">{{ customer.company }}<br></span>
              <span cdkDrag
                    [class.cdk-drag--keep-opacity]="viewOnly"
                    [cdkDragData]="setDragData(customer, ['birthday'])"
                    [cdkDragDisabled]="checkIfExists(customer.birthday, 'birthday')">
                <span class="birthday" *ngIf="customer.birthday">
                  {{ customer.birthday.date | date:customer.birthday.format }} - {{ getAge(customer.birthday.date) }}
                  <span i18n="After age number text@@customerOverviewComponent.text.yearsOld">years old</span>
                </span>
                <span *ngIf="!customer.birthday" class="birthday" [class.cdk-drag-placeholder]="!customer.birthday">
                  /
                </span>
              </span>

            </small>
          </p>

        </div>
      </div>
    </div>

  </ng-container>

  <ng-container *ngSwitchCase="tablesTranslations.i18nComunicationData">

    <div class="esf-info-tile-grid__item"
         cdkDropList
         [id]="id"
         cdkDropListSortingDisabled
         [cdkDropListData]="customer"
         cdkDropListConnectedTo="mergedCustomerCommunication">
      <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
        <span class="esf-action-heading__text">{{ type }}</span>
      </h4>
      <div class="esf-info-tile" style="flex: 1;">
        <div class="esf-info-tile__content">

          <div class="esf-icon-and-text esf-icon-and-text--xs"
               cdkDrag
               [class.cdk-drag--keep-opacity]="viewOnly"
               [cdkDragData]="setDragData(customer, ['mobile'])"
               [cdkDragDisabled]="checkIfExists(customer.mobile, 'mobile')">
            <svg class="esf-icon" width="16" height="16" [attr.edsTooltip]="tooltipTranslations.i18nMobile">
              <use xlink:href="#esf-icon-tablet"></use>
            </svg>
            <div class="esf-icon-and-text__text" [class.cdk-drag-placeholder]="!customer.mobile">{{ customer.mobile || '/' }}</div>
          </div>
          <div class="esf-icon-and-text esf-icon-and-text--xs"
               cdkDrag
               [class.cdk-drag--keep-opacity]="viewOnly"
               [cdkDragData]="setDragData(customer, ['phone'])"
               [cdkDragDisabled]="checkIfExists(customer.phone, 'phone')">
            <svg class="esf-icon" width="16" height="16" [attr.edsTooltip]="tooltipTranslations.i18nTelephone">
              <use xlink:href="#esf-icon-phone"></use>
            </svg>
            <div class="esf-icon-and-text__text" [class.cdk-drag-placeholder]="!customer.phone">{{ customer.phone || '/' }}</div>
          </div>

          <div class="esf-icon-and-text esf-icon-and-text--xs"
               cdkDrag
               [class.cdk-drag--keep-opacity]="viewOnly"
               [cdkDragData]="setDragData(customer, ['searchEmail','equalAuthorizationAndEmail', 'externalAuthorization'])"
               [cdkDragDisabled]="checkIfExists(customer.searchEmail, 'searchEmail')"
               [ngSwitch]="customer.equalAuthorizationAndEmail">
            <ng-container *ngSwitchCase="true">
              <svg class="esf-icon" width="16" height="16" [attr.edsTooltip]="tooltipTranslations.i18nEmailAuthorization">
                <use xlink:href="#esf-icon-mail-authorized"></use>
              </svg>
            </ng-container>

            <ng-container *ngSwitchCase="false">
              <svg class="esf-icon" width="16" height="16" [attr.edsTooltip]="tooltipTranslations.i18nEmail">
                <use xlink:href="#esf-icon-mail"></use>
              </svg>
            </ng-container>

            <div class="esf-icon-and-text__text elipsis" [class.cdk-drag-placeholder]="!customer.searchEmail">{{ customer.searchEmail || '/' }}</div>
          </div>

        </div>
      </div>

    </div>

  </ng-container>

  <ng-container *ngSwitchCase="tablesTranslations.i18nAttribute">

    <div class="esf-info-tile-grid__item"
         cdkDropList
         [id]="id"
         cdkDropListSortingDisabled
         [cdkDropListData]="customer"
         cdkDropListConnectedTo="mergedCustomerAttributes">
      <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
        <span class="esf-action-heading__text">{{ type }}</span>
      </h4>
      <div class="esf-info-tile" style="flex: 1;">

        <ng-container *ngIf="!customer['attributes']?.length">
          <div class="esf-grid__item">
            <section class="esf-empty-state flex-empty-state"
                     app-empty-state
                     [emptyStateIcon]="'#esf-icon-attributes'"
                     [emptyStateText]="tablesTranslations.i18nNoAttributes">
            </section>
          </div>
        </ng-container>

        <ng-container *ngIf="customer['attributes']?.length">
          <div class="esf-info-tile__content">

            <div class="flex-attributes">
              <div class="esf-tags attribute-padding" *ngFor="let attribute of customer.attributes">
                <span class="esf-tag"
                      [ngClass]="{'esf-tag--alert': attribute.status === 'inactive', 'text-color-dark': !attribute.isDark, 'text-color-light': attribute.isDark}"
                      [style.background-color]="attribute.color"
                      cdkDrag
                      [class.cdk-drag--keep-opacity]="viewOnly"
                      [cdkDragData]="attribute"
                      [cdkDragDisabled]="checkIfExists(attribute, 'attributes')"
                      [class.cdk-drag-placeholder]="!attribute">
                  {{attribute.name}}
                </span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

  </ng-container>

  <ng-container *ngSwitchCase="tablesTranslations.i18nMembership">

    <div class="esf-info-tile-grid__item"
         cdkDropList
         [id]="id"
         cdkDropListSortingDisabled
         [cdkDropListData]="customer"
         cdkDropListConnectedTo="mergedCustomerMembership">
      <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
        <span class="esf-action-heading__text">{{ type }}</span>
      </h4>

      <div class="esf-info-tile">
        <div class="esf-info-tile__content" *ngIf="customer.membership">
          <div class="esf-grid esf-grid--gutter-y-xxs esf-grid--x-between esf-grid--center-y"
               cdkDrag
               [class.cdk-drag--keep-opacity]="viewOnly"
               [cdkDragData]="setDragData(customer, ['membership'])"
               [cdkDragDisabled]="checkIfExists(customer.membership, 'membership')">
            <div class="esf-grid__item">
              <div class="esf-icon-and-text esf-icon-and-text--xs">
                <svg class="esf-icon esf-icon-and-text__icon" width="16" height="16">
                  <use xlink:href="#esf-icon-membership-number"></use>
                </svg>
                <div class="esf-icon-and-text__text">{{ customer.membership.membershipNumber }}</div>
              </div>
            </div>
            <div class="esf-grid__item" [class.cdk-drag-placeholder]="!customer.membership.status.class">
              <a class="esf-tag" [ngClass]="customer.membership.status.class">{{ customer.membership.status.status || '/' }}</a>
            </div>
          </div>

        </div>

        <ng-container *ngIf="!customer.membership">
          <div class="esf-grid__item">
            <section class="esf-empty-state flex-empty-state"
                     app-empty-state
                     [emptyStateIcon]="'#esf-icon-membership-number'"
                     [emptyStateText]="tablesTranslations.i18nNoMembership">
            </section>
          </div>
        </ng-container>

      </div>
    </div>

  </ng-container>

  <ng-container *ngSwitchCase="tablesTranslations.i18nMembershipCampai">

    <div class="esf-info-tile-grid__item"
         cdkDropList
         [id]="id"
         cdkDropListSortingDisabled
         [cdkDropListData]="customer"
         cdkDropListConnectedTo="mergedCustomerMembership">
      <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
        <span class="esf-action-heading__text">{{ type }}</span>
      </h4>

      <div class="esf-info-tile">
        <div class="esf-info-tile__content" *ngIf="customer.campaiMembership">
          <div class="esf-grid esf-grid--gutter-y-xxs esf-grid--x-between esf-grid--center-y"
               cdkDrag
               [class.cdk-drag--keep-opacity]="viewOnly"
               [cdkDragData]="setDragData(customer, ['campaiMembership'])"
               [cdkDragDisabled]="checkIfExists(customer.campaiMembership, 'campaiMembership')">
            <div class="esf-grid__item">
              <div class="esf-icon-and-text esf-icon-and-text--xs">
                <svg class="esf-icon esf-icon-and-text__icon" width="16" height="16">
                  <use xlink:href="#esf-icon-membership-number"></use>
                </svg>
                <div class="esf-icon-and-text__text">{{ customer.campaiMembership.membershipNumber }}</div>
              </div>
            </div>
            <div class="esf-grid__item" [class.cdk-drag-placeholder]="!customer.campaiMembership.status.class">
              <a class="esf-tag" [ngClass]="customer.campaiMembership.status.class">{{ customer.campaiMembership.status.status || '/' }}</a>
            </div>
          </div>

        </div>

        <ng-container *ngIf="!customer.campaiMembership">
          <div class="esf-grid__item">
            <section class="esf-empty-state flex-empty-state"
                     app-empty-state
                     [emptyStateIcon]="'#esf-icon-membership-number'"
                     [emptyStateText]="tablesTranslations.i18nNoMembership">
            </section>
          </div>
        </ng-container>

      </div>
    </div>

  </ng-container>

  <ng-container *ngSwitchCase="tablesTranslations.i18nStandardAddress">

    <div class="esf-info-tile-grid__item"
         cdkDropList
         [id]="id"
         cdkDropListSortingDisabled
         [cdkDropListData]="customer"
         cdkDropListConnectedTo="mergedCustomerStandardAddress">
      <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
        <span class="esf-action-heading__text">{{ type }}</span>
      </h4>
      <div class="esf-info-tile" style="flex: 1;">
        <div class="esf-info-tile__content" *ngIf="getAddresses('standard').length">
            <p *ngFor="let address of getAddresses('standard')"
               cdkDrag
               [class.cdk-drag--keep-opacity]="viewOnly"
               [cdkDragData]="address"
               [cdkDragDisabled]="checkIfExists(address, 'addresses')">
              <span class="street">{{ address.street }} </span><br>
              <span class="city">{{ address.postalCode }} {{ address.city }}</span><br>
            </p>

        </div>

        <ng-container *ngIf="!getAddresses('standard').length">
          <div class="esf-grid__item">
            <section class="esf-empty-state flex-empty-state"
                     app-empty-state
                     [emptyStateIcon]="'#esf-icon-location'"
                     [emptyStateText]="tablesTranslations.i18nNoAddresses">
            </section>
          </div>
        </ng-container>
      </div>

    </div>

  </ng-container>

  <ng-container *ngSwitchCase="tablesTranslations.i18nAddresses">

    <div class="esf-info-tile-grid__item"
         cdkDropList
         [id]="id"
         cdkDropListSortingDisabled
         [cdkDropListData]="customer"
         cdkDropListConnectedTo="mergedCustomerAddresses">
      <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
        <span class="esf-action-heading__text">{{ type }}</span>
      </h4>
      <div class="esf-info-tile" style="flex: 1;">
        <div class="esf-info-tile__content" *ngIf="getAddresses().length">
          <p *ngFor="let address of getAddresses()"
             cdkDrag
             [class.cdk-drag--keep-opacity]="viewOnly"
             [cdkDragData]="address"
             [cdkDragDisabled]="checkIfExists(address, 'addresses')">
            <span class="full-name">{{ address.firstName }} {{ address.lastName }}</span><br>
            <span class="street">{{ address.street }} </span><br>
            <span class="city">{{ address.postalCode }} {{ address.city }}</span><br>
          </p>
        </div>

        <ng-container *ngIf="!getAddresses().length">
          <div class="esf-grid__item">
            <section class="esf-empty-state flex-empty-state"
                     app-empty-state
                     [emptyStateIcon]="'#esf-icon-location'"
                     [emptyStateText]="tablesTranslations.i18nNoAddresses">
            </section>
          </div>
        </ng-container>
      </div>

    </div>

  </ng-container>

  <ng-container *ngSwitchCase="tablesTranslations.i18nInvoices">

    <div class="esf-info-tile-grid__item"
         cdkDropList
         [id]="id"
         cdkDropListSortingDisabled
         [cdkDropListData]="customer">
      <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
        <span class="esf-action-heading__text">{{ type }}</span>
      </h4>
      <div class="esf-info-tile" style="flex: 1;">
        <div class="esf-info-tile__content" *ngIf="customer.invoices?.length">
          <p *ngFor="let invoice of customer.invoices"
             cdkDrag
             [class.cdk-drag--keep-opacity]="viewOnly"
             [cdkDragData]="invoice"
             [cdkDragDisabled]="checkIfExists(invoice, 'invoice')">
            <span class="full-name">
              {{ invoice.date.date | date:'dd.MM.yyyy' }} | {{ invoice.totalAmount.value | currency:invoice.totalAmount.currency:'code':undefined:locale }} | {{ invoice.branch }}
            </span>
          </p>
        </div>
        <ng-container *ngIf="!customer.invoices?.length">
          <div class="esf-grid__item">
            <section class="esf-empty-state flex-empty-state"
                     app-empty-state
                     [emptyStateIcon]="'#esf-icon-ticket'"
                     [emptyStateText]="tablesTranslations.i18nNoInvoices">
            </section>
          </div>
        </ng-container>
      </div>

    </div>

  </ng-container>

  <ng-container *ngSwitchCase="tablesTranslations.i18nMerchandising">

    <div class="esf-info-tile-grid__item"
         cdkDropList
         [id]="id"
         cdkDropListSortingDisabled
         [cdkDropListData]="customer">
      <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
        <span class="esf-action-heading__text">{{ type }}</span>
      </h4>
      <div class="esf-info-tile" style="flex: 1;">
        <div class="esf-info-tile__content" *ngIf="customer.merchandising?.length">
          <p *ngFor="let merch of customer.merchandising"
             cdkDrag
             [class.cdk-drag--keep-opacity]="viewOnly"
             [cdkDragData]="merch"
             [cdkDragDisabled]="checkIfExists(merch, 'merchandising')">
            <span class="full-name">
              {{ merch.purchaseDateTime.date | date:'dd.MM.yyyy' }} | {{ merch.priceTotal | currency:merch.currency:'code':undefined:locale }} | {{ merch.quantity }} 
            </span>
            <span>Items</span>
          </p>
        </div>
        <ng-container *ngIf="!customer.merchandising?.length">
          <div class="esf-grid__item">
            <section class="esf-empty-state flex-empty-state"
                     app-empty-state
                     [emptyStateIcon]="'#esf-icon-merch'"
                     [emptyStateText]="tablesTranslations.i18nNoMerchandising">
            </section>
          </div>
        </ng-container>
      </div>

    </div>

  </ng-container>

</span>
